export default function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}


//////////////////
// WEBPACK FOOTER
// /var/www/clients/client0/web6/deploy/releases/20230327134040/web/app/themes/metadieta/node_modules/@popperjs/core/lib/utils/getMainAxisFromPlacement.js
// module id = 17
// module chunks = 0